import axios from "axios";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import toastr from '../../../utils/toast';

function Candidaterefform({ refcandidateid,candidate_id , onclose }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [data, setData] = useState([]);

const getRefData = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/candidates/get_feedback/${candidate_id}/${refcandidateid}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    let feedback = "";
    let attribute = "positive";
    if (response.data?.refNotes?.length > 0 ) {
      feedback = response.data.refNotes[0].feedback;
      attribute = response.data.refNotes[0].attribute;
    }
    setValue("feedback",feedback);
    setValue("attribute",attribute);
  } catch (error) {
    console.error("Error fetching feedback data:", error);
  }
};

useEffect(() => {
  if (!candidate_id || !refcandidateid ) return;
  getRefData();
  console.log(candidate_id+', '+refcandidateid);
}, [candidate_id, refcandidateid]);

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/candidates/add_feedback`,
        {
          ref:refcandidateid,
          can : candidate_id,
          feedback: data.feedback,
          attribute: data.attribute,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      onclose();
      getRefData();
      toastr.success("Feedback updated.");
      // if (response.data.length > 0) {
      //   setOptions(response.data);
      // }
    } catch (error) {
      console.log(error);
    } finally {
      setGlobalLoading(false);
    }
  };
  const {
      register,
      setValue,
      formState: { errors },
      handleSubmit,
    } = useForm();
  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg" style={{maxWidth:"500px"}}>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Reference Feedback</h4>
              <button type="button" onClick={onclose} className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-xxl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="card-body my-card-body">
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <textarea className="form-control" type="text" placeholder="Your Feedback..." {...register("feedback")}/>
                        </div>
                      </div>
                      <div className="col-md-12 p-3">
                          <select {...register("attribute")} className="form-select">
                            <option value="positive">positive</option>
                            <option value="negative">negative</option>
                          </select>
                        </div>
                      </div>
                      <div className="text-center">
                        <button type="submit" className="btn btn-primary">Submit</button>
                      </div>
                    </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Candidaterefform;
